module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-26-08-052.8b7c3bde.mp4";